import { Injectable } from '@angular/core';
import { produce } from 'immer';
import { QuestionStructureOptions } from '../models/question/question-options.model';
import { QuestionStructureRepeater } from '../models/question/question-repeater.model';
import { Question } from '../models/question/question.model';
import { RendererQuestionsRepository } from '../repositories/renderer-questions.repository';

@Injectable({ providedIn: 'root' })
export class RendererQuestionsCommand {
  constructor(
    protected rendererQuestionsRepository: RendererQuestionsRepository,
  ) {}

  public setQuestions(questions: Question[]) {
    for (const question of questions) {
      const filteredQuestion = this.filterOrder(question, questions);
      this.setQuestion(filteredQuestion);
    }
  }

  public setQuestion(question: Question) {
    this.rendererQuestionsRepository.upsert(question);
  }

  public setActive(questionId: string) {
    this.rendererQuestionsRepository.setActive(questionId);
  }

  public unsetActive() {
    // eslint-disable-next-line unicorn/no-null
    this.rendererQuestionsRepository.setActive(null);
  }

  public removeQuestions(questions: string[]) {
    this.rendererQuestionsRepository.remove(questions);
  }

  public reset() {
    this.rendererQuestionsRepository.reset();
  }

  public updateHoverQuestion(questionId) {
    this.rendererQuestionsRepository.setHoverQuestion(questionId);
  }

  public updateIsDragging(isDragging) {
    this.rendererQuestionsRepository.setIsDragging(isDragging);
  }

  private filterOrder(question: Question, questionList: Question[]) {
    return produce(question, (draft) => {
      let order: string[][];
      const questionStructureOptions =
        draft.structure as QuestionStructureOptions;
      const questionStructureRepeater =
        draft.structure as QuestionStructureRepeater;
      if (questionStructureOptions.followUpQuestionsOrder) {
        order = questionStructureOptions.followUpQuestionsOrder;
      } else if (questionStructureRepeater.repeaterQuestionsOrder) {
        order = questionStructureRepeater.repeaterQuestionsOrder;
      } else {
        return;
      }
      for (const [index, row] of order.entries()) {
        order[index] = row.filter((qId) =>
          questionList.some((q) => q.id === qId),
        );
      }

      order = order.filter((o) => o.length > 0);
      if (questionStructureOptions.followUpQuestionsOrder) {
        questionStructureOptions.followUpQuestionsOrder = order;
      } else if (questionStructureRepeater.repeaterQuestionsOrder) {
        questionStructureRepeater.repeaterQuestionsOrder = order;
      }
    });
  }
}
